export const euProjectsSlugEN: string =
	'/what-we-offer/research/government-funded-research/public-funded-projects'
export const euProjectsSlugNL: string =
	'/vlaamse-innovatiemotor/samenwerking/gesubsidieerde-projecten'
export const euProjectsSlugDefault: string = euProjectsSlugEN
export const euProjectsSlugLocale: (l: string) => string = (lang) =>
	lang === 'nl' ? euProjectsSlugNL : euProjectsSlugEN
